import { useLang } from "@/contexts/LanguageContext";

export default function Story({ property }) {
  const { t, lang } = useLang();
  const story = property.story[lang];
  return (
    <section id="historia" data-testid="story-section" className="bg-[#FAFAF9] py-24 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <p className="text-eyebrow text-[#E07A5F] mb-4">{t("story.eyebrow")}</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-stone-900">
            {story.title}
          </h2>
        </div>
        <div className="lg:col-span-7 space-y-6 text-stone-700 text-lg leading-relaxed">
          <p className="first-letter:text-6xl first-letter:font-serif-display first-letter:float-left first-letter:mr-3 first-letter:leading-[0.85] first-letter:text-[#E07A5F]">
            {story.p1}
          </p>
          <p>{story.p2}</p>
          <p className="font-serif-display italic text-2xl md:text-3xl text-stone-800 leading-snug pt-6 border-t border-stone-200">
            “{story.p3}”
          </p>
        </div>
      </div>
    </section>
  );
}
